<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 2376 2622"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <g transform="matrix(1.00073,0,0,0.99874,0.851136,158.498)">
      <g id="longsleeve_5_back">
        <g
          id="gradient-colour"
          transform="matrix(17.7495,0,0,17.7989,-12980.5,3364.16)"
        >
          <path
            d="M764.457,-126.329L751.286,-65.108L751.226,-65.067C751.144,-65.015 749.125,-63.71 743.439,-63.231C742.927,-63.19 742.411,-63.171 741.899,-63.171C736.754,-63.171 731.95,-65.138 731.898,-65.16L731.767,-65.213L731.782,-65.351C731.812,-65.654 746.451,-159.903 748.194,-165.395C749.844,-170.616 751.917,-174.087 754.353,-175.732C754.345,-175.776 754.337,-175.82 754.33,-175.863L754.311,-175.989L754.419,-176.057C754.763,-176.266 755.125,-176.446 755.496,-176.583C758.011,-177.522 771.657,-182.349 777.526,-184.416C778.005,-184.584 778.432,-184.737 778.798,-184.864C778.798,-184.89 778.794,-184.913 778.794,-184.939C778.846,-185.003 778.899,-185.067 778.951,-185.13C778.973,-185.131 778.996,-185.132 779.018,-185.133C780.151,-186.477 781.654,-187.935 783.182,-188.519C793.153,-189.098 803.032,-188.858 813.003,-188.279C814.532,-187.696 817.351,-184.877 817.351,-184.851C817.717,-184.724 818.298,-184.584 818.78,-184.416C824.654,-182.341 838.291,-177.522 840.804,-176.583C841.174,-176.446 841.537,-176.266 841.884,-176.057L841.907,-176.043L841.911,-176.068L842.143,-175.926C844.711,-174.371 846.887,-170.831 848.606,-165.395C850.349,-159.903 864.988,-65.654 865.018,-65.351L865.033,-65.213L864.902,-65.16C864.85,-65.138 860.046,-63.171 854.901,-63.171C854.389,-63.171 853.873,-63.19 853.361,-63.231C847.675,-63.71 845.656,-65.015 845.574,-65.067L845.514,-65.108L832.057,-127.661C831.736,-125.697 831.545,-124.348 831.496,-123.677C831.178,-119.55 833.488,-65.973 833.514,-65.361L833.518,-65.267L833.447,-65.211C827.554,-60.265 809.614,-59.711 801.894,-59.711C799.883,-59.711 798.563,-59.749 798.332,-59.756L798.152,-59.764L797.969,-59.756C797.737,-59.749 796.417,-59.711 794.409,-59.711C786.69,-59.711 768.745,-60.265 762.857,-65.211L762.786,-65.267L762.79,-65.361C762.812,-65.973 765.126,-119.55 764.808,-123.677C764.769,-124.183 764.65,-125.076 764.457,-126.329Z"
            :style="{ fill: `url(#linear${id})` }"
          />
        </g>
        <g
          id="primary-colour"
          transform="matrix(17.7495,0,0,17.7989,-12980.5,3364.16)"
        >
          <path
            d="M764.457,-126.329L751.286,-65.108L751.226,-65.067C751.144,-65.015 749.125,-63.71 743.439,-63.231C742.927,-63.19 742.411,-63.171 741.899,-63.171C736.754,-63.171 731.95,-65.138 731.898,-65.16L731.767,-65.213L731.782,-65.351C731.812,-65.654 746.451,-159.903 748.194,-165.395C749.844,-170.616 751.538,-174.078 753.974,-175.723C753.966,-175.767 755.125,-176.446 755.496,-176.583C758.011,-177.522 771.657,-182.349 777.526,-184.416C778.005,-184.584 778.432,-184.737 778.798,-184.864C778.798,-184.89 778.794,-184.913 778.794,-184.939C778.846,-185.003 778.899,-185.067 778.951,-185.13C778.973,-185.131 778.996,-185.132 779.018,-185.133C780.151,-186.477 781.654,-187.935 783.182,-188.519C793.153,-189.098 802.963,-188.941 812.934,-188.362C814.462,-187.778 815.966,-186.32 817.098,-184.976C817.121,-184.975 817.144,-184.974 817.166,-184.973C817.218,-184.91 817.457,-185.003 817.51,-184.939C817.51,-184.913 817.506,-184.89 817.506,-184.864C817.872,-184.737 818.298,-184.584 818.78,-184.416C824.654,-182.341 838.291,-177.522 840.804,-176.583C841.174,-176.446 841.537,-176.266 841.884,-176.057L841.907,-176.043L841.911,-176.068L842.143,-175.926C844.711,-174.371 846.887,-170.831 848.606,-165.395C850.349,-159.903 864.988,-65.654 865.018,-65.351L865.033,-65.213L864.902,-65.16C864.85,-65.138 860.046,-63.171 854.901,-63.171C854.389,-63.171 853.873,-63.19 853.361,-63.231C847.675,-63.71 845.656,-65.015 845.574,-65.067L845.514,-65.108L831.815,-127.661C831.494,-125.697 831.254,-123.677 831.254,-123.677L764.808,-123.677C764.808,-123.677 764.65,-125.076 764.457,-126.329Z"
            :style="{
              fill: productColors.primary_1.value,
              transition: 'all 500ms',
            }"
          />
        </g>
        <g
          id="outline"
          transform="matrix(17.7495,0,0,17.7989,-20285.3,-228.111)"
        >
          <path
            d="M1209.62,142.38L1209.28,142.38L1209.27,142.381C1209.02,142.388 1207.7,142.426 1205.71,142.426C1201.07,142.426 1192.74,142.225 1185.54,140.995C1180.71,140.168 1176.38,138.868 1174,136.871L1174,136.867L1173.93,136.817C1173.89,136.756 1173.85,136.688 1173.84,136.607L1173.84,136.518C1173.86,135.905 1176.18,82.355 1175.86,78.23C1175.84,77.943 1175.79,77.533 1175.72,77.003L1162.82,136.79L1162.73,136.909L1162.67,136.948C1162.67,136.95 1162.66,136.952 1162.66,136.954C1162.64,136.967 1162.52,137.046 1162.27,137.167L1162.22,137.2L1162.23,137.189C1161.36,137.606 1159.13,138.46 1154.76,138.828C1154.24,138.869 1153.72,138.888 1153.2,138.888C1148.04,138.888 1143.22,136.93 1143.1,136.88L1142.98,136.83C1142.89,136.755 1142.84,136.667 1142.82,136.566L1142.83,136.435C1142.86,136.131 1157.51,41.834 1159.26,36.339C1161,30.826 1163.04,27.161 1165.64,25.584L1165.64,25.586C1165.98,25.381 1166.34,25.206 1166.71,25.069C1169.23,24.13 1182.87,19.303 1188.74,17.235C1189.22,17.068 1189.64,16.917 1190.01,16.79C1191.17,15.414 1192.73,13.921 1194.31,13.323L1194.34,13.309L1194.38,13.307C1204.42,12.727 1214.49,12.727 1224.54,13.307L1224.58,13.309L1224.61,13.323C1226.19,13.922 1227.75,15.418 1228.92,16.797C1229.28,16.922 1229.69,17.071 1230.16,17.235C1236.04,19.31 1249.68,24.13 1252.19,25.069C1252.58,25.213 1252.95,25.398 1253.31,25.617C1253.32,25.618 1253.32,25.619 1253.32,25.62L1253.42,25.684C1253.47,25.714 1253.5,25.749 1253.51,25.786L1253.53,25.749C1256.13,27.326 1258.4,30.826 1260.14,36.339C1261.89,41.827 1276.5,135.903 1276.57,136.432L1276.57,136.435L1276.58,136.566C1276.59,136.676 1276.54,136.744 1276.48,136.786L1276.41,136.831L1276.42,136.83L1276.3,136.88C1276.25,136.902 1271.4,138.888 1266.2,138.888C1265.68,138.888 1265.16,138.869 1264.64,138.828C1260.2,138.453 1257.96,137.575 1257.13,137.167L1256.76,136.963C1256.75,136.96 1256.75,136.956 1256.74,136.954C1256.74,136.952 1256.74,136.95 1256.73,136.948L1256.67,136.909C1256.63,136.873 1256.6,136.833 1256.58,136.79L1243.42,75.413C1243.21,76.752 1243.08,77.702 1243.04,78.23C1242.73,82.354 1245.04,135.903 1245.06,136.516L1245.07,136.607C1245.07,136.633 1245.07,136.656 1245.06,136.677L1244.96,136.82L1244.97,136.817L1244.91,136.867L1244.9,136.871C1242.52,138.868 1238.2,140.168 1233.36,140.995C1226.16,142.225 1217.84,142.426 1213.19,142.426C1211.22,142.426 1209.91,142.389 1209.64,142.381L1209.62,142.38ZM1209.46,141.883C1209.46,141.883 1211.19,141.926 1213.19,141.926C1217.82,141.926 1226.11,141.727 1233.28,140.502C1238,139.695 1242.23,138.45 1244.56,136.504C1244.49,134.873 1242.23,82.282 1242.55,78.192C1242.6,77.504 1242.8,76.105 1243.13,74.064L1243.13,74.042L1243.13,74.04C1243.37,72.622 1243.67,70.895 1244.03,68.884C1245.85,58.719 1248.7,44.275 1249.47,41.286L1249.66,40.583C1250.52,37.28 1252.12,31.136 1253.02,26.022C1252.69,25.83 1252.36,25.665 1252.02,25.538C1249.51,24.599 1235.87,19.781 1230,17.706C1229.53,17.544 1229.12,17.396 1228.76,17.272C1227.55,17.22 1226.33,17.171 1225.12,17.126C1224.12,17.089 1223.11,17.059 1222.11,17.029C1213.68,16.783 1205.24,16.783 1196.81,17.029C1195.81,17.059 1194.8,17.089 1193.8,17.126C1192.58,17.171 1191.37,17.22 1190.15,17.272L1190.14,17.273C1189.78,17.397 1189.37,17.545 1188.91,17.706C1183.04,19.774 1169.4,24.599 1166.88,25.538C1166.54,25.666 1166.2,25.83 1165.88,26.023C1166.78,31.137 1168.38,37.28 1169.25,40.583L1169.43,41.286C1170.2,44.275 1173.06,58.719 1174.88,68.884C1175.76,73.809 1176.27,77.025 1176.36,78.191C1176.67,82.281 1174.41,134.905 1174.34,136.504C1176.68,138.45 1180.91,139.695 1185.63,140.502C1192.79,141.727 1201.09,141.926 1205.71,141.926C1207.71,141.926 1209.23,141.89 1209.46,141.883ZM1165.43,26.324C1163.12,28.001 1161.32,31.467 1159.73,36.49C1158.01,41.916 1143.69,134.041 1143.34,136.436C1143.82,136.63 1148.36,138.388 1153.2,138.388C1153.7,138.388 1154.21,138.37 1154.72,138.329C1160.02,137.882 1162.09,136.715 1162.36,136.549L1175.51,75.592C1175.26,73.97 1174.88,71.743 1174.39,68.972C1172.57,58.821 1169.72,44.396 1168.94,41.411L1168.76,40.708C1167.91,37.442 1166.34,31.408 1165.43,26.324ZM1244.75,136.926L1244.72,136.844L1244.72,136.843L1244.75,136.926ZM1253.48,26.305C1252.57,31.393 1250.99,37.439 1250.14,40.709L1249.96,41.411C1249.18,44.396 1246.34,58.821 1244.52,68.972C1244.16,70.949 1243.87,72.65 1243.64,74.051L1257.04,136.55C1257.31,136.716 1259.38,137.882 1264.68,138.329C1265.19,138.37 1265.7,138.388 1266.2,138.388C1271.04,138.388 1275.58,136.63 1276.06,136.436C1275.71,134.041 1261.39,41.916 1259.67,36.49C1258.02,31.276 1255.92,27.896 1253.48,26.305ZM1228.21,16.749C1227.15,15.552 1225.83,14.33 1224.47,13.804C1214.47,13.228 1204.45,13.228 1194.45,13.805C1193.09,14.332 1191.76,15.553 1190.7,16.748C1191.73,16.705 1192.76,16.665 1193.78,16.627C1194.79,16.59 1195.79,16.56 1196.79,16.53C1205.24,16.283 1213.68,16.283 1222.12,16.53C1223.13,16.56 1224.13,16.59 1225.13,16.627C1226.16,16.665 1227.19,16.706 1228.21,16.749ZM1253.27,26.275L1253.11,26.075L1253.1,26.073L1253.27,26.275ZM1276.13,136.542L1276.14,136.548L1276.14,136.543L1276.13,136.537L1276.13,136.542ZM1244.63,136.601L1244.64,136.611L1244.64,136.608L1244.63,136.598L1244.63,136.601ZM1276.2,136.899L1276.18,136.793L1276.18,136.792L1276.2,136.899Z"
            style="fill: #808080"
          />
        </g>
        <g
          id="cheeta-logo"
          v-if="cheetaLogo.position === 'back'"
          transform="matrix(2.9694,0,0,2.97315,1061.17,111.014)"
        >
          <path
            d="M11.062,7.23l0.679,-2.689l-3.915,0l-0.678,2.689l-1.072,4.252l-0.678,2.687l3.916,-0l0.677,-2.687l4.769,0l-1.113,4.413c-0.375,1.485 -1.71,2.526 -3.242,2.526l-6.555,0c-2.178,0 -3.775,-2.049 -3.242,-4.16l2.886,-11.446c0.374,-1.485 1.71,-2.525 3.241,-2.525l6.557,0c2.178,0 3.774,2.049 3.242,4.161l-0.701,2.78l-4.771,-0.001Zm16.353,-6.745l4.768,0l-2.205,8.551l-0.617,2.446l-1.749,6.94l-4.77,0l1.751,-6.94l-3.916,0l-1.75,6.941l-4.769,0l4.572,-17.938l4.769,0l-1.75,6.745l3.915,0l1.751,-6.745Zm9.614,4.056l-0.678,2.689l6.766,0l-1.072,4.252l-6.766,0l-0.679,2.687l6.766,-0l-1.072,4.253l-11.533,-0l4.571,-17.937l11.536,-0l-1.073,4.056l-6.766,-0Zm12.577,0l-0.68,2.689l6.766,0l-1.071,4.252l-6.766,0l-0.678,2.687l6.766,-0l-1.073,4.253l-11.534,-0l4.572,-17.937l11.535,-0l-1.071,4.056l-6.766,-0Zm22.235,-4.056l-1.072,4.056l-4.215,0l-3.499,13.881l-4.769,0l3.5,-13.881l-4.471,0l1.072,-4.056l13.454,0Zm0.511,2.329c0.375,-1.485 1.712,-2.525 3.243,-2.525l6.556,0c2.177,0 3.774,2.048 3.242,4.16l-3.522,13.972l-4.77,0l1.071,-4.252l0.679,-2.687l-3.916,0l-0.677,2.687l-1.071,4.252l-4.77,0l3.936,-15.607l-0.001,0Zm7.57,4.416l0.678,-2.689l-3.916,0l-0.678,2.689l3.916,0Zm-62.945,20.44l1.99,-7.811l4.646,0l-0.271,1.024l-3.313,0l-0.574,2.274l3.308,0l-0.282,1.12l-3.308,0l-0.575,2.274l3.31,0l-0.282,1.119l-4.649,0Zm-5.147,-0l1.712,-6.787l-2.178,-0l0.27,-1.024l5.586,-0l-0.271,1.024l-2.065,-0l-1.711,6.787l-1.343,-0Zm15.767,0.028l0.374,-1.482l0.482,-1.911l-2.905,-0l-0.855,3.394l-1.342,-0l1.774,-7.034c0.129,-0.514 0.59,-0.873 1.12,-0.873l3.206,-0c0.358,-0 0.69,0.162 0.911,0.445c0.22,0.283 0.296,0.645 0.209,0.992l-1.631,6.47l-1.343,-0.001Zm-1.767,-4.513l2.905,0l0.573,-2.275l-2.905,0l-0.573,2.275Zm27.998,4.491l1.99,-7.81l4.644,0l-0.27,1.024l-3.313,0l-0.573,2.274l3.308,0l-0.282,1.119l-3.308,0l-0.575,2.274l3.309,0l-0.282,1.119l-4.648,0Zm10.608,0.029l0.373,-1.483l0.483,-1.911l-2.906,0l-0.854,3.394l-1.343,0l1.775,-7.034c0.129,-0.513 0.589,-0.873 1.12,-0.873l3.205,0c0.359,0 0.691,0.162 0.912,0.445c0.22,0.284 0.296,0.645 0.209,0.992l-1.631,6.47l-1.343,0Zm-1.767,-4.513l2.904,0l0.574,-2.274l-2.905,0l-0.573,2.274Zm-18.914,4.471c-0.359,0 -0.691,-0.162 -0.912,-0.445c-0.221,-0.283 -0.296,-0.645 -0.209,-0.992l1.63,-6.36l1.34,0l-1.711,6.678l2.905,0l1.712,-6.678l1.34,0l-1.711,6.678l2.905,0l1.711,-6.678l1.343,0l-1.992,7.797l-8.351,0Zm-4.519,0l1.711,-6.677l-2.905,0l-1.712,6.677l-1.341,0l1.712,-6.677l-2.905,0l-1.711,6.677l-1.343,0l1.991,-7.797l8.353,0c0.359,0 0.691,0.162 0.912,0.445c0.22,0.284 0.296,0.645 0.209,0.992l-1.63,6.36l-1.341,0Zm32.222,0.046l-0.227,-3.392l-1.654,0l-0.856,3.394l-1.342,0l1.23,-4.877l0.332,-1.314l0.433,-1.717l4.105,0c0.359,0 0.691,0.162 0.912,0.445c0.22,0.284 0.296,0.645 0.209,0.992l-0.557,2.202c-0.116,0.462 -0.512,0.809 -0.985,0.864l-0.455,0.053l0.224,3.35l-1.369,0Zm-1.6,-4.511l2.906,-0l0.573,-2.273l-2.904,-0l-0.575,2.273Z"
            :style="{
              fill: cheetaLogo.color.value,
              transition: 'all 500ms',
              fillRule: 'nonzero',
            }"
          />
        </g>
      </g>
    </g>
    <rect
      id="logo-mask-1"
      x="716.231"
      y="589.85"
      width="946.655"
      height="1014.17"
      style="fill: none"
    />
    <use
      id="full-back-logo"
      :xlink:href="`#backFull${id}`"
      x="410"
      y="330"
      width="460px"
      height="514px"
      transform="matrix(1.71038,0,0,1.71038,503.522,577.002)"
    />
    <rect
      id="logo-mask-2"
      x="713.936"
      y="679.36"
      width="948.128"
      height="440.115"
      style="fill: none"
    />
    <use
      id="back-centre-logo"
      :xlink:href="`#backCenter${id}`"
      x="3750"
      y="3800"
      width="943px"
      height="306px"
      transform="matrix(1,0,0,1,-2558.56,-2895.51)"
    />
    <rect
      id="logo-mask-3"
      x="1074.65"
      y="264.884"
      width="236.764"
      height="124.687"
      style="fill: none"
    />
    <clipPath id="_clip4">
      <rect x="750" y="200" width="800" height="500" />
    </clipPath>
    <g clip-path="url(#_clip4)">
      <use
        id="under-back-logo"
        :xlink:href="`#backUpper${id}`"
        x="1550"
        y="850"
        width="300px"
        height="136px"
        transform="matrix(0.794512,0,0,0.794512,-47.2027,-287.969)"
      />
    </g>
    <g
      v-if="activePlayer"
      id="number-mask"
      transform="matrix(1.00273,0,0,1.00273,-3.2435,-7.15463)"
    >
      <path
        d="M424.767,864.943L1930.59,864.943L1852.68,1325.87L1856.26,1518.97L507.8,1522.97L510.377,1326.92L424.767,864.943Z"
        style="fill: none"
      />
      <clipPath id="_clip2">
        <path
          d="M424.767,864.943L1930.59,864.943L1852.68,1325.87L1856.26,1518.97L507.8,1522.97L510.377,1326.92L424.767,864.943Z"
        />
      </clipPath>
      <g clip-path="url(#_clip2)">
        <g
          id="player-number"
          serif:id="player number"
          transform="matrix(0.997277,0,0,0.997277,569.2,1454.36)"
        >
          <text
            text-anchor="middle"
            x="600"
            :y="`${activePlayer.playerNumberBackVerticalPosition * 10}px`"
            :style="{
              fontFamily: details.fontFamily,
              fontSize: `${activePlayer.playerNumberBackSize * 10}px`,
              fill: details.fontColor.value,
            }"
          >
            {{ activePlayer.number }}
          </text>
        </g>
      </g>
    </g>
    <g
      v-if="activePlayer"
      id="player-mask"
      transform="matrix(1.00273,0,0,1.00273,-3.2435,-7.15463)"
    >
      <path
        d="M2010.14,499.977L348.109,499.977L410.018,799.45L1943.88,799.45L2010.14,499.977Z"
        style="fill: none"
      />
      <clipPath id="_clip3">
        <rect x="350" y="0" width="2000" height="1100" style="fill: none" />
      </clipPath>
      <g clip-path="url(#_clip3)">
        <g
          id="player-name"
          serif:id="player name"
          transform="matrix(0.997277,0,0,0.997277,780.994,738.7)"
        >
          <text
            text-anchor="middle"
            x="400"
            :y="`${activePlayer.nameBackVerticalPosition * 5.85 - 230}`"
            :style="{
              fontFamily: details.fontFamily,
              fontSize: `${activePlayer.nameSize * 10}`,
              fill: details.fontColor.value,
              zIndex: 1000,
            }"
          >
            {{ activePlayer.name }}
          </text>
        </g>
      </g>
    </g>
    <defs>
      <BackLogoImages :logos="{ backFullLogo, backUpperLogo }" :id="id" />

      <linearGradient
        :id="`linear${id}`"
        x1="0"
        y1="0"
        x2="1"
        y2="0"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(3.51147e-13,-103.495,-143.345,-4.86072e-13,798.4,-59.7114)"
      >
        <stop
          offset="0"
          :style="{
            stopColor: productColors.primary_2.value,
            stopOpacity: 1,
            transition: 'all 500ms',
          }"
        />
        <stop
          offset="0.5"
          :style="{
            stopColor: productColors.primary_1.value,
            stopOpacity: 1,
            transition: 'all 500ms',
          }"
        />
        <stop
          offset="1"
          :style="{
            stopColor: productColors.primary_1.value,
            stopOpacity: 1,
            transition: 'all 500ms',
          }"
        />
      </linearGradient>
      <svg:style>
        {{ fontFace }}
      </svg:style>
    </defs>
  </svg>
</template>

<script>
import { getFontFace } from "@/assets/fonts/fontsBase64";
import { computed } from "vue";
import BackLogoImages from "@/components/SVGImagesAsComponents/Common/BackLogoImages";
export default {
  name: "LongSleeve_6_back",
  components: { BackLogoImages },
  props: ["productColors", "logo", "activePlayer", "cheetaLogo", "details"],
  setup(props) {
    const id = Math.floor(Math.random() * 10000).toString();
    const fontFace = computed(() => getFontFace(props.details.fontFamily));

    const backFullLogo = computed(() => props.logo.backFull);
    const backCenterLogo = computed(() => props.logo.backCenter);
    const backUpperLogo = computed(() => props.logo.backUpper);

    return {
      id,
      fontFace,
      backFullLogo,
      backCenterLogo,
      backUpperLogo,
    };
  },
};
</script>
